module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "campus-life-left.b4d13ec8.jpeg" + "?" + Date.now();